/**
 * @generated SignedSource<<74d50fbb2172f4f74a2ecf07ed617e40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferHistory_offerHistory$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly guid: string;
      readonly " $fragmentSpreads": FragmentRefs<"OfferHistoryItem_offer">;
    };
  }>;
  readonly id: string;
  readonly " $fragmentType": "OfferHistory_offerHistory";
};
export type OfferHistory_offerHistory$key = {
  readonly " $data"?: OfferHistory_offerHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferHistory_offerHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./OfferStatusRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "OfferHistory_offerHistory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OfferStatusEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferStatus",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OfferHistoryItem_offer"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "OfferStatusConnection",
  "abstractKey": null
};

(node as any).hash = "09ea33f5492cdc1a6bfcf77d2b2b623e";

export default node;
